import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { articles } from "../data/content";
import {
  applySeo, clearArticleJsonLd, clearPageJsonLd, PAGE_JSON_LD, SEO_ROUTES, setArticleJsonLd,
  setPageJsonLd, NOT_FOUND_SEO, trimToWords,
} from "../lib/seo";

const UNTOUCHED = ["/admin", "/desk", "/unsubscribe"];

/** Owns the head tags for every public route. Rendered once, inside the Router. */
export const SeoManager = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (UNTOUCHED.some((prefix) => pathname.startsWith(prefix))) return;

    const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";

    if (path.startsWith("/education/")) {
      const article = articles.find((item) => item.slug === path.slice("/education/".length));
      if (article) {
        clearPageJsonLd();
        const url = applySeo({
          title: article.seoTitle || `${article.title} | OHC Benefits`,
          description: trimToWords(article.excerpt),
          path,
          ogType: "article",
        });
        setArticleJsonLd(article, url);
        return;
      }
    }
    clearArticleJsonLd();

    const graph = PAGE_JSON_LD[path];
    if (graph) setPageJsonLd(graph);
    else clearPageJsonLd();

    if (path.startsWith("/book/") || path.startsWith("/booking/")) {
      applySeo({
        title: document.title,
        description: SEO_ROUTES["/"].description,
        path,
        robots: "noindex, follow",
      });
      return;
    }

    const route = SEO_ROUTES[path];
    if (route) {
      applySeo({ ...route, path });
      return;
    }

    applySeo({ ...NOT_FOUND_SEO, path });
  }, [pathname]);

  return null;
};
